import React, {useEffect, useState} from 'react';
import {Button, Divider, Form, Input, message, Result, Select, Spin, Steps, Alert, Checkbox} from 'antd';
import parsePhoneNumber from "libphonenumber-js";
import {useMutation, useQuery} from "react-query";
import {CreateConsoleProfile, GetDictsConsole} from "../../../api/console";


const steps = [
    {title: "Тип разработчика"},
    {title: "Заявка"},
    {title: "Проверка"},
];

export const ConsoleCreateProfile = (props) => {
    const [step, setStep] = useState(0);
    const [developerType, setDeveloperType] = useState(null);
    const [developerId, setDeveloperId] = useState(null);

    const CreateDeveloperMutation = useMutation(
        (data) => CreateConsoleProfile(data),
        {
            onSuccess: (data, vars) => {
                message.success(`Аккаунт успешно создан`);
                setDeveloperId(data.id);
                setStep(2);
            },
            onError: (e) => {
                console.error(`[CreateDeveloperMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )

    const onSelectDeveloperType = (developerType) => {
        window.location.hash = `#${developerType}`;
        setDeveloperType(developerType);
    }

    useEffect(() => {
        const onHashChange = () => {
            if (window.location.hash === '') {
                setStep(0);
            }
        };

        window.addEventListener('hashchange', onHashChange);
        return () => {
            window.removeEventListener('hashchange', onHashChange);
        }
    }, []);

    useEffect(() => {
        if (developerType !== null) {
            setStep(1);
        }
    }, [developerType]);


    const CreateProfile = (data) => {
        CreateDeveloperMutation.mutate({...data, ...{type: developerType}});
    }


    return (
        <div className={`console create_profile`}>
            <div className="console--steps">
                <Steps current={step} responsive={true}>
                    {steps.map(item => (
                        <Steps.Step key={item.title} title={item.title}/>
                    ))}
                </Steps>
            </div>
            <div className="console--content">
                {step === 0 && (<>
                    <div style={{marginTop: 24}}>
                        <Alert
                            type={`info`}
                            message={`В магазине приложений NashStore можно зарегистрироваться как физическим лицам, так и юрлицам. Выберите пункт, который относится к владельцу приложения.`}
                        />
                    </div>
                    <DeveloperTypes onSelect={onSelectDeveloperType}/>
                </>)}
                {step === 1 && (
                    <Spin spinning={CreateDeveloperMutation.isLoading}>
                        <DeveloperForm
                            profile={props.profile}
                            developerType={developerType}
                            createProfile={CreateProfile}
                        />
                    </Spin>
                )}
                {step === 2 && (<Result
                    status={"success"}
                    title={"Аккаунт разработчика успешно создан"}
                    subTitle={"Сейчас он находится на этапе модерации, вы можете пока настроить страницу разработчика и начать загружать приложения"}
                    extra={[
                        <Button type="primary" key="console"
                                onClick={() => window.location.href = `/console/${developerId}`}>
                            Перейти в аккаунт
                        </Button>,
                    ]}
                />)}
            </div>
        </div>
    );
}

const DeveloperTypes = ({onSelect}) => {
    return (
        <div className={`console--developers__types`}>
            <div className={`developer__type`}>
                <div className="icon"><span className={`mdi mdi-account`}/></div>
                <div className="title">Индивидуальный разработчик</div>
                <div className="description">
                    Это физическое лицо или гражданин России, зарегистрированный в качестве самозанятого
                </div>
                <div className="actions">
                    <Button type={`primary`} onClick={() => onSelect('developer')}>Выбрать</Button>
                </div>
            </div>
            <div className={`developer__type`}>
                <div className="icon"><span className={`mdi mdi-account-multiple`}/></div>
                <div className="title">Индивидуальный предприниматель</div>
                <div className="description">Это физлицо, зарегистрированное для ведения коммерческой деятельности в установленном порядке без образования юрлица</div>
                <div className="actions">
                    <Button type={`primary`} onClick={() => onSelect('IndividualEntrepreneur')}>Выбрать</Button>
                </div>
            </div>
            <div className={`developer__type`}>
                <div className="icon"><span className={`mdi mdi-account-group`}/></div>
                <div className="title">Организация</div>
                <div className="description">Это юрлица любой организационно-правовой формы, в том числе общественные организации, фонды, банковские и госструктуры</div>
                <div className="actions">
                    <Button type={`primary`} onClick={() => onSelect('company')}>Выбрать</Button>
                </div>
            </div>
        </div>
    );
}

export const DeveloperForm = (props) => {
    const {
        profile,
        developerType,
        createProfile,
        hideTitle = false,
        initialValue = false,
        buttonText = 'Создать аккаунт'
    } = props;
    const {data, isLoading} = useQuery('console_dicts', GetDictsConsole)
    const [ form ] = Form.useForm();

    const IsRussianCountry = () => {
        if (initialValue !== false) {
            return initialValue.country_id === 1;
        }
        return false;
    }

    const [isValidEmail, setValidEmail] = useState(false);
    const [isValidPhone, setValidPhone] = useState(false);
    const [isRussian, setIsRussian] = useState(IsRussianCountry());


    const onFieldsChange = (_, allFields) => {
        let email = allFields.filter(i => i.name.indexOf('email') + 1 > 0);
        setValidEmail(email && email.length > 0 && email[0].value && email[0].errors.length === 0);
    }

    return (
        <div className={`appc profile`}>
            {!hideTitle && (<h1>Регистрация разработчика</h1>)}
            <Form
                form={form}
                name={`developer_form`}
                autoComplete={'off'}
                layout={`vertical`}
                onFieldsChange={onFieldsChange}
                onFinish={(values) => {
                    createProfile(values);
                }}
                initialValues={initialValue !== false ? initialValue : {
                    email: profile?.email || "",
                    phone: profile?.phone || "",
                }}
            >
                <div className="console--block">
                    <Form.Item
                        label={`Страна`}
                        name={`country_id`}
                        rules={[{required: true, message: `Выберите страну`}]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="children"
                            loading={isLoading}
                            placeholder={`Выберите страну`}
                            onChange={(value) => {
                                setIsRussian(value === 1);
                                form.setFieldsValue({
                                    region_id: "",
                                    city_id: "",
                                })
                            }}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {data?.countries && data?.countries.map(i => <Select.Option
                                value={i.id}>{i.name}</Select.Option>)}
                        </Select>
                    </Form.Item>
                    {isRussian && (
                        <>
                            <Form.Item
                                label={`Регион`}
                                name={`region_id`}
                                showSearch
                                optionFilterProp="children"
                                loading={isLoading}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                rules={[{required: true, message: `Выберите регион`}]}
                            >
                                <Select loading={isLoading} placeholder={`Выберите регион`}>
                                    {data?.regions && data?.regions.map(i => <Select.Option
                                        value={`${i.id}`}>{i.name}</Select.Option>)}
                                </Select>
                            </Form.Item>
                        </>
                    )}
                    {!isRussian && (
                        <>
                            <Form.Item label={`Регион`} name={`region_id`}
                                       rules={[{required: true, message: `Укажите регион`}]}>
                                <Input placeholder={`Укажите регион`}/>
                            </Form.Item>
                        </>
                    )}

                    <Form.Item
                        label={`Город`}
                        name={`city_id`}
                        rules={[{required: true, message: `Выберите город`}]}
                    >
                        <Input placeholder={`Укажите ваш город`}/>
                    </Form.Item>
                    <Form.Item
                        label={`Адрес`}
                        name={`address`}
                        rules={[{required: true, message: `Укажите почтовый адрес`}]}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={`Телефон`}
                        name={`phone`}
                        rules={[
                            {required: true, message: `Укажите номер телефона`},
                            {
                                validator: async (_, phone = '') => {
                                    // const { short, phone, code } = names;
                                    const phoneNumber = parsePhoneNumber(phone);
                                    if (!phoneNumber || !phoneNumber.isValid()) {
                                        setValidPhone(false);
                                        return Promise.reject(new Error('Введен не корректный номер телефона'));
                                    } else {
                                        setValidPhone(phone !== '');
                                    }
                                }
                            },
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={`Email`}
                        name={`email`}
                        rules={[
                            {required: true, message: 'Укажите ваш почтовый адрес'},
                            {type: 'email', message: 'Укажите корректный почтовый адрес'},
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                </div>
                <Divider>Информация о разработчике</Divider>
                <div className="console--block">
                    <Form.Item
                        label={`Наименование`}
                        name={`title`}
                        rules={[
                            {required: true, message: 'Заполните название разработчика'},
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={`Веб-сайт`}
                        name={`website`}
                        extra={`Укажите официальный сайт либо ссылку на общедоступную страницу с информацией о разработчике. К примеру аккаунт в социальной сети.`}
                        rules={[
                            {type: 'url', warningOnly: true, message: `Введена не корректная ссылка`}
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    {developerType === 'company' && (
                        <>
                            <Form.Item label={`ФИО представителя`} name={'contact_name'} rules={[
                                {required: true, message: 'Заполните ФИО представителя'},

                            ]}>
                                <Input/>
                            </Form.Item>
                            <Form.Item label={`Должность представителя`} name={'contact_position'} rules={[
                                {required: true, message: 'Заполните должность представителя'},

                            ]}>
                                <Input/>
                            </Form.Item>
                        </>
                    )}
                    <Form.Item
                        label={isRussian ? `ИНН` : 'ID Компании'}
                        name={`inn`}
                        rules={[
                            {required: true, message: isRussian ? `Заполните ИНН` : 'Заполните ID компании'},
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        name={`developer_rules`}
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value ? Promise.resolve() : Promise.reject(new Error('Необходимо принять условия')),
                            },
                        ]}
                    >
                        <Checkbox>Я принимаю условия <a href={"/rules/developers"} target={"_blank"}>оферты для разработчиков электронных приложений</a>.</Checkbox>
                    </Form.Item>
                </div>
                <div className={`console--actions`}>
                    <Button type={`primary`} htmlType={`submit`}>{buttonText}</Button>
                </div>
            </Form>
        </div>
    );
}

export default ConsoleCreateProfile;